const Cookie = require("tiny-cookie");
import * as Url from "url-parse";
const utmParamKeys = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign"];

export const write = () => {
  const url = new Url(window.location.href, {}, true);
  utmParamKeys.forEach((key) => {
    if (url.query[key]) {
      Cookie.set(key, url.query[key], { expires: "1M" });
    }
  });
};

export const read = () => {
  return utmParamKeys.reduce(
    (hash, key) =>
      Object.assign(
        {
          [key]: Cookie.get(key) || null
        },
        hash
      ),
    {}
  );
};

export const clear = () => {
  utmParamKeys.forEach((key) => {
    Cookie.remove(key);
  });
};
